import { useRef, useState } from 'react';
import Button from '@mui/material/Button';
import { countNumeros } from '../utils/parseNumeros';

const MAX_PREVIEW_NUMEROS = 5000;

function CargarArchivo({ onFileLoaded, onError, disabled = false, fileInfo = null }) {
  const fileInputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  const processFile = async (file) => {
    const isTxt =
      file.name.toLowerCase().endsWith('.txt') ||
      file.type === 'text/plain' ||
      file.type === '';

    if (!isTxt) {
      onError?.('Solo se permiten archivos .txt');
      return;
    }

    try {
      const text = await file.text();
      const count = countNumeros(text);

      if (count === 0) {
        onError?.('El archivo no contiene números telefónicos.');
        return;
      }

      onFileLoaded({
        file,
        text,
        fileName: file.name,
        count,
        previewInTextarea: count <= MAX_PREVIEW_NUMEROS,
      });
    } catch {
      onError?.('No se pudo leer el archivo.');
    }
  };

  const handleInputChange = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = '';
    await processFile(file);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    if (!disabled) {
      setIsDragging(true);
    }
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = async (event) => {
    event.preventDefault();
    setIsDragging(false);

    if (disabled) {
      return;
    }

    const file = event.dataTransfer.files?.[0];
    await processFile(file);
  };

  return (
    <div
      className={`app-cargar-archivo${isDragging ? ' app-cargar-archivo--dragging' : ''}`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <p className="app-panel-label">Cargar desde archivo (no superar los 100k telefonos)</p>

      <input
        ref={fileInputRef}
        type="file"
        accept=".txt,text/plain"
        hidden
        onChange={handleInputChange}
      />

      <Button
        variant="outlined"
        color="primary"
        disabled={disabled}
        onClick={() => fileInputRef.current?.click()}
        fullWidth
        className="app-cargar-archivo__button"
      >
        Cargar archivo .txt
      </Button>

      <p className="app-cargar-archivo__hint">
        Arrastrá un .txt aquí o usá el botón.
      </p>

      {fileInfo ? (
        <div className="app-file-info">
          <span className="app-file-info__label">Archivo cargado</span>
          <strong className="app-file-info__name">{fileInfo.fileName}</strong>
          <span className="app-file-info__count">
            {fileInfo.count.toLocaleString('es-AR')} números
          </span>
        </div>
      ) : (
        <div className="app-cargar-archivo__placeholder">
          Seleccioná un archivo txt.
        </div>
      )}
    </div>
  );
}

export default CargarArchivo;
